var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6235 14.9681C21.6235 18.4002 17.4336 19.7951 12.2277 19.7951C7.02184 19.7951 2.77148 18.4002 2.77148 14.9681C2.77148 11.536 6.99439 8.75731 12.1948 8.75731C17.4006 8.75731 21.6235 11.5415 21.6235 14.9681Z",
    fill: "#4BAF74"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6626 7.4833C20.6626 5.67663 19.1854 4.20493 17.3678 4.20493C16.3409 4.20493 15.4293 4.6717 14.8252 5.40205C14.0015 5.22084 13.1229 5.1165 12.2168 5.1165C11.3052 5.1165 10.4321 5.21535 9.60838 5.40205C8.99883 4.6717 8.08176 4.20493 7.06585 4.20493C5.24819 4.20493 3.771 5.67114 3.771 7.4833C3.771 8.07638 3.93025 8.63101 4.20482 9.10876C3.94123 9.66889 3.80394 10.262 3.80394 10.8825C3.80394 14.0675 7.57655 16.6485 12.2223 16.6485C16.868 16.6485 20.6406 14.0675 20.6406 10.8825C20.6406 10.262 20.4979 9.66889 20.2398 9.10876C20.5034 8.63101 20.6626 8.07638 20.6626 7.4833Z",
    fill: "#32DA6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79672 9.30097C7.90599 9.30097 8.81208 8.40587 8.81208 7.2966C8.81208 6.19282 7.91148 5.29223 6.79672 5.29223C5.68746 5.29223 4.78137 6.18733 4.78137 7.2966C4.78686 8.40587 5.68746 9.30097 6.79672 9.30097Z",
    fill: "#F1F1E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5379 9.30097C18.6472 9.30097 19.5533 8.40587 19.5533 7.2966C19.5533 6.19282 18.6527 5.29223 17.5379 5.29223C16.4232 5.29223 15.5226 6.18733 15.5226 7.2966C15.5226 8.40587 16.4232 9.30097 17.5379 9.30097Z",
    fill: "#F1F1E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72585 19.5589C6.15967 19.5589 6.50014 19.1855 6.45072 18.7572C6.27499 17.2525 5.52267 13.9961 2.22232 12.0357C-2.17081 9.42727 1.30525 18.4057 1.30525 18.4057L0.393679 18.9274C0.0861592 19.1032 0.217953 19.5589 0.563912 19.5589H5.72585Z",
    fill: "#32DA6D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8339 19.5589C18.444 19.5589 18.1365 19.1855 18.1805 18.7572C18.3342 17.258 19.0152 13.9961 21.9915 12.0357C25.9618 9.42727 22.8207 18.4057 22.8207 18.4057L23.6444 18.9274C23.919 19.1032 23.8037 19.5589 23.4907 19.5589H18.8339Z",
    fill: "#32DA6D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79675 8.28716C7.34899 8.28716 7.79675 7.8394 7.79675 7.30208C7.79675 6.74985 7.34899 6.31701 6.79675 6.31701C6.24451 6.31701 5.79675 6.76477 5.79675 7.30208C5.81168 7.8394 6.25944 8.28716 6.79675 8.28716Z",
    fill: "#0D0D0D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.538 8.28167C18.0902 8.28167 18.538 7.83391 18.538 7.2966C18.538 6.74436 18.0902 6.31152 17.538 6.31152C16.9857 6.31152 16.538 6.75928 16.538 7.2966C16.538 7.83391 16.9857 8.28167 17.538 8.28167Z",
    fill: "#0D0D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeap);
export default __webpack_public_path__ + "static/media/leap.cac0e070d1c607124ccd69ca5a9f1fe4.svg";
export { ForwardRef as ReactComponent };